<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Kitap Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <!-- <span><strong>Not:</strong> Eklenecek podcast adı ve arama motoru
                  bağlantı linki benzersiz olmalıdır...</span> -->
            </div>
          </b-alert>
          <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
            :to="`/books/create`">
            Yeni Kitap Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Kitaplar">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table">
                  <thead>
                    <th>#</th>
                    <th>KİTAP</th>
                    <th>YAZAR</th>
                    <th>TARİH</th>
                    <th>ÇEVİRİLER</th>
                    <th>SİL</th>
                  </thead>
                  <draggable v-model="books" class="cursor-move" tag="tbody" @change="outputData">
                    <tr v-for="book in books" :key="book.id">
                      <td>{{ book.id }}</td>
                      <td>{{ book.name }}</td>
                      <td>{{ book.writer }}</td>
                      <td>{{ book.createdAt }}</td>
                      <td>
                        <b-button-group>
                          <b-button v-for="language in languages" :key="language.locale"
                            @click="action(book, language.locale)" v-ripple.400="'rgba(113, 102, 240, 0.15)'" :variant="book.languages.find((element) => element == language.locale)
                                ? 'outline-warning'
                                : 'outline-secondary'
                              " :title="book.languages.find((element) => element == language.locale)
                                ? 'Düzenle'
                                : 'Ekle'
                              ">
                            {{ language.locale.toUpperCase() }}
                          </b-button>
                        </b-button-group>
                      </td>
                      <b-button-group>
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-danger"
                          class="btn-icon rounded-circle" @click="deleteConfirmText(book.id)">
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </b-button-group>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>KİTAP</th>
                    <th>YAZAR</th>
                    <th>TARİH</th>
                    <th>ÇEVİRİLER</th>
                    <th>SİL</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      books: [],
      request: [],
      languages: [],
    };
  },
  watch: {},
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);
      if (translationControl == undefined) {
        this.$router.push({
          path: `/books/create/translation/${node.id}?targetLocale=${locale}`,
        });
      } else {
        this.$router.push({
          path: `/books/edit/${node.id}?targetLocale=${locale}`,
        });
      }
    },
    actionPreview(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);
      if (translationControl == undefined) {
      } else {
        // window.open(`${settings.uiBaseUrl}/contents/preview/${node.slugs[locale]}?hl=${locale}`, '_blank');
        window.open(`${settings.uiBaseUrl}/library?hl=${locale}`, "_blank");
      }
    },
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.books).forEach(([key, value]) => {
        let booksOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(booksOrder);
      });
      endpoints
        .putBooksOrder({ books: this.request }, this.$i18n.locale, () => { })
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Kitap sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBooks() {
      endpoints
        .getBooks(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.books = [];
          this.books = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Kitabı silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteBooks(id, this.$i18n.locale, () => { })
        .then((data) => {
          this.getBooks();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Kitap silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getBooks();
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card>.card-body {
  padding: 10px;
}

.draggable-card>.card-body>.card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
